import React, {createContext, useContext, useState} from 'react';

const CustomNoteContext = createContext({});

export const useNoteContext = () => useContext(CustomNoteContext);

export const NoteProvider = ({children}) => {

  const [isPendingNoteNeedToRefresh, setIsPendingNoteNeedToRefresh] = useState(false);

  return (
    <CustomNoteContext.Provider
      value={[isPendingNoteNeedToRefresh, setIsPendingNoteNeedToRefresh]}
    >
      {children}
    </CustomNoteContext.Provider>
  );
};